// Copyright © 2021 Move Closer
import { TokenType } from '@d24/demarked';
import { AbstractAdapter } from '../../../_abstract/adapter';
import { ModuleDriver } from '../../../_contracts';
import { getModuleBase } from '../../../_helpers/adapter';
import { EmbedVersion } from '../../Embed.contracts';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export class EmbedIframeAdapter extends AbstractAdapter {
    /**
     * Adapts (translates/maps) the passed-in `EmbedModule` to the `EmbedToken`.
     *
     * @param object - The module to adapt.
     * @param storage
     */
    objectToToken(object, storage) {
        if (!storage) {
            throw new Error('Argument of storage should be present to [image] module');
        }
        const { content } = object;
        this.validate(content, {
            description: {
                type: 'string'
            },
            iframe: {
                presence: true,
                type: 'string',
                length: { minimum: 1 }
            }
        });
        const { description, iframe } = content;
        const id = storage.uniqueKey();
        storage.store(id, iframe);
        let raw;
        if (typeof description === 'string' && description.length > 0) {
            raw = `#EMBED[ id: ${id} | description: ${description} ]`;
        }
        else {
            raw = `#EMBED[ id: ${id} ]`;
        }
        const token = {
            content: id,
            raw,
            type: TokenType.Embed
        };
        if (typeof description === 'string') {
            token.meta = { description };
        }
        return token;
    }
    /**
     * Adapts (translates/maps) the passed-in `EmbedToken` to the `EmbedModule`.
     *
     * @param token - The token to adapt.
     * @param storage
     */
    tokenToObject(token, storage) {
        if (!storage) {
            throw new Error('Argument of storage should be present to [embed] module');
        }
        this.validate(token, {
            content: {
                presence: true,
                type: 'string'
            }
        });
        const { content } = token;
        const object = {
            ...getModuleBase(),
            content: {},
            driver: ModuleDriver.Embed,
            version: EmbedVersion.Iframe
        };
        const id = token.content;
        if (typeof id === 'undefined') {
            throw new Error('[Embed.adapter - tokenToObject] IFrame is not defined');
        }
        const stored = storage.retrieve(id);
        object.content = {
            ...object.content,
            iframe: stored
        };
        if (typeof token.meta !== 'undefined') {
            this.validate(token.meta, {
                description: {
                    type: 'string',
                    length: { minimum: 1 }
                }
            });
            const { description } = token.meta;
            if (typeof description !== 'undefined' && description.length > 0) {
                object.content.description = description;
            }
        }
        object.content.type = EmbedVersion.Iframe;
        return object;
    }
}
